import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 1,
  class: "cancelled-stamp-lite"
}
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = {
  key: 2,
  src: "/img/flags/default.svg",
  alt: "Default Logo",
  class: "country-flag"
}
const _hoisted_6 = { class: "game-details" }
const _hoisted_7 = { class: "draw-time" }
const _hoisted_8 = {
  key: 0,
  class: "results"
}
const _hoisted_9 = { class: "numbers-wrap" }
const _hoisted_10 = { class: "action-section" }
const _hoisted_11 = {
  key: 0,
  class: "countdown-box"
}
const _hoisted_12 = { class: "countdown-block" }
const _hoisted_13 = { class: "countdown-number" }
const _hoisted_14 = { class: "countdown-label" }
const _hoisted_15 = { class: "countdown-block" }
const _hoisted_16 = { class: "countdown-number" }
const _hoisted_17 = { class: "countdown-label" }
const _hoisted_18 = { class: "countdown-block" }
const _hoisted_19 = { class: "countdown-number" }
const _hoisted_20 = { class: "countdown-label" }

import {
  getGameLogoUrl,
  isResultCancelled,
  parseBonusNumbers,
  parseMainNumbers,
} from '@/utils/resultParser';
import { computed, ref, onMounted, onUnmounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useIntegrationMode } from '@/composables/useIntegrationMode'
import CountryAvatar from '@/components/base/CountryAvatar.vue'

/** Shared app asset — not theme-scoped (see public/img/cancelled.png). */

const __default__ = {
  name: 'LotteryResultCard'
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    lottery: {}
  },
  setup(__props: any) {

const CANCELLED_EVENT_IMAGE = '/img/cancelled.png';
const CANCELLED_EVENT_IMAGE_FALLBACK = '/img/cancelled.svg';

const router = useRouter();
const route = useRoute();
const { isLite } = useIntegrationMode();
const cancelledImgSrc = ref(CANCELLED_EVENT_IMAGE);

function useCancelledSvgFallback() {
  if (cancelledImgSrc.value !== CANCELLED_EVENT_IMAGE_FALLBACK) {
    cancelledImgSrc.value = CANCELLED_EVENT_IMAGE_FALLBACK;
  }
}

const props = __props

const isCancelled = computed(() => isResultCancelled(props.lottery ?? undefined));

const mainNumbers = computed(() => parseMainNumbers(props.lottery?.result));
const bonusNumbers = computed(() => parseBonusNumbers(props.lottery?.result));

const formattedDrawTime = computed(() => {
  const drawDate = props.lottery?.draw_date;
  if (!drawDate) return '';

  const dateString = String(drawDate).trim();
  let date: Date;

  // Normalize and parse
  if (dateString.includes('+')) {
    // Example: "2025-07-29 23:51:30+00:00"
    const [datePart, offset] = dateString.split('+');
    date = new Date(datePart.replace(' ', 'T') + '+' + offset);
  } else if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(dateString)) {
    // "YYYY-MM-DD HH:mm:ss" → Assume UTC
    date = new Date(dateString.replace(' ', 'T') + 'Z');
  } else {
    date = new Date(dateString);
  }

  if (isNaN(date.getTime())) return '';

  // Format as "29/07/2025, 23:51:30" in local time
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');

  return `${day}/${month}/${year}, ${hours}:${minutes}:${seconds}`;
});


const isMobile = computed(() => window.matchMedia('(max-width: 768px)').matches)

const isResultsView = computed(() => {
  // Check if we're in the Results view by looking at the current route
  return window.location.pathname.includes('/results')
})

const truncatedName = computed(() => {
  const game_name = props.lottery?.game_name || ''
  if (isMobile.value) return game_name
  return game_name.length > 15 ? game_name.slice(0, 15) + '...' : game_name
})

// Navigation function
const navigateToDetail = () => {
  if (props.lottery && props.lottery.game_slug) {
    router.push({ path: `/lottery/${props.lottery.game_slug}`, query: route.query });
  }
}

// Countdown logic
const countdown = ref({ hours: 0, minutes: 0, seconds: 0 })
let timer: number
const updateCountdown = () => {
  if (!props.lottery?.draw_date) {
    countdown.value = { hours: 0, minutes: 0, seconds: 0 }
    return
  }
  const now = new Date()
  
  // Parse the UTC date string properly for countdown
  const dateString = String(props.lottery.draw_date)
  let drawTime: Date
  
  if (dateString.includes('+')) {
    // UTC format like "2025-07-29 23:51:30+00:00"
    const datePart = dateString.split('+')[0]
    drawTime = new Date(datePart + 'Z')
  } else {
    // Fallback for other formats
    drawTime = new Date(dateString)
  }
  
  const diff = drawTime.getTime() - now.getTime()
  if (diff <= 0) {
    countdown.value = { hours: 0, minutes: 0, seconds: 0 }
    return
  }
  countdown.value = {
    hours: Math.floor(diff / (1000 * 60 * 60)),
    minutes: Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60)),
    seconds: Math.floor((diff % (1000 * 60)) / 1000)
  }
}
onMounted(() => {
  countdown.value = { hours: 0, minutes: 0, seconds: 0 }
  updateCountdown()
  timer = window.setInterval(updateCountdown, 1000)
})
onUnmounted(() => {
  if (timer) clearInterval(timer)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["lottery-result-card", { 'lottery-result-card--cancelled': isCancelled.value }])
  }, [
    (isCancelled.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "cancelled-overlay",
          role: "img",
          "aria-label": _ctx.$t('results.cancelled')
        }, [
          (!_unref(isLite) && cancelledImgSrc.value)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: cancelledImgSrc.value,
                alt: "",
                class: "cancelled-stamp",
                onError: useCancelledSvgFallback
              }, null, 40, _hoisted_2))
            : (_unref(isLite))
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.$t('results.cancelled')), 1))
              : _createCommentVNode("", true)
        ], 8, _hoisted_1))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "flag-section",
      onClick: navigateToDetail
    }, [
      (_unref(isLite))
        ? (_openBlock(), _createBlock(CountryAvatar, {
            key: 0,
            country: _ctx.lottery?.country,
            "fallback-label": _ctx.lottery?.game_name,
            size: "lg"
          }, null, 8, ["country", "fallback-label"]))
        : (_ctx.lottery && _ctx.lottery.game_logo)
          ? (_openBlock(), _createElementBlock("img", {
              key: 1,
              src: _unref(getGameLogoUrl)(_ctx.lottery.game_logo, _ctx.lottery.game_slug),
              alt: _ctx.lottery.country,
              class: "country-flag"
            }, null, 8, _hoisted_4))
          : (_openBlock(), _createElementBlock("img", _hoisted_5))
    ]),
    _createElementVNode("div", {
      class: "content-section",
      onClick: navigateToDetail
    }, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("h3", null, _toDisplayString(_ctx.lottery?.game_name), 1),
        _createElementVNode("div", _hoisted_7, _toDisplayString(formattedDrawTime.value), 1)
      ]),
      (!isCancelled.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mainNumbers.value, (number) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: 'main-' + number,
                  class: "number-ball"
                }, _toDisplayString(number), 1))
              }), 128)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bonusNumbers.value, (number) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: 'bonus-' + number,
                  class: "number-ball bonus"
                }, _toDisplayString(number), 1))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_10, [
      (isMobile.value && !isResultsView.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, _toDisplayString(String(countdown.value.hours).padStart(2, '0')), 1),
              _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('time.hours')), 1)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, _toDisplayString(String(countdown.value.minutes).padStart(2, '0')), 1),
              _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t('time.mins')), 1)
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, _toDisplayString(String(countdown.value.seconds).padStart(2, '0')), 1),
              _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t('time.secs')), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      (!isMobile.value || isResultsView.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "bet-button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('bet')))
          }, _toDisplayString(_ctx.$t('results.betOnNextDraw')), 1))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})